import { getApi } from "../../common/api";

export const getSummary = (country: string) => {
    const endpoint = country === 'india' ? '/api/dashBoard/indian-summary' : '/api/dashBoard/summary';
    return getApi(endpoint);
};

export const getRevenueOver = (country: string) => {
    const endpoint = country === 'india' ? '/api/dashBoard/indian-revenue-over-time' : '/api/dashBoard/revenue-over-time';
    return getApi(endpoint);
};

export const getPendingApprovals = (country: string) => {
    const endpoint = country === 'india' ? '/api/dashBoard/indian-pending-approvals' : '/api/dashBoard/pending-approvals';
    return getApi(endpoint);
};

export const getRecentListing = (country: string) => {
    const endpoint = country === 'india' ? '/api/dashBoard/indian-recent-listings' : '/api/dashBoard/recent-listings';
    return getApi(endpoint);
};